module.exports = __webpack_public_path__ + "static/media/mira_decision_text_search.bb24e324.png";